var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"scholar"}},[_c('TopList',{attrs:{"navList":_vm.navList},on:{"setType":_vm.setType}}),(_vm.type === 0)?_c('UserInfo',{ref:"UserInfo"}):_vm._e(),(_vm.type === 1)?_c('Personage'):_vm._e(),(_vm.type === 2)?_c('Scholarship',{attrs:{"sysUserPrize":_vm.sysUserPrize}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }